module.exports = __webpack_public_path__ + "img/favicon_pms.b0a72291.png";